import React, { useMemo } from 'react';
import DraggableTable from 'components/blazeTable/Draggable/DraggableTable';
import { RecordingMessage } from 'types/rest/assetCatalogTypes';
import { BlazeTableColDef } from 'components/blazeTable/BlazeTable.types';
import _ from 'lodash';
import BzmIcon from 'components/icons/BzmIcon';
import clsx from 'clsx';
import RecordingMessageSimpleView from '../../../../AssetCatalog/Recordings/Messages/RecordingMessageSimpleView';
import { getRecordingMessageWithFormat } from '../../../../AssetCatalog/Recordings/Messages/RecordingMessages';
import { messageTypes } from '../../../../../types/rest/dslTypes';

export enum Move {
  start,
  end,
}

interface DraggableMessagesIndexTableProps {
  isLoading: boolean;
  messages: RecordingMessage[];
  onSelectionChange: (items: any[]) => void;
  onDragFinished: (items: any[]) => void;
  moveMessage: (message: RecordingMessage, where: Move) => void;
  selectedItems: number[] | null;
}
const DraggableMessagesIndexTable = (props: DraggableMessagesIndexTableProps) => {
  const getSize = () => useMemo(() => _.size(props.messages), [props.messages]);

  const getTableColumns = () => {
    // Definition of table columns
    const colsDefinition: BlazeTableColDef[] = [
      {
        header: 'Index',
        accessor: 'index',
        width: 100,
      },
      {
        header: 'Name',
        accessor: 'name',
      },
      {
        header: 'Type',
        cellComponent: (message: RecordingMessage) => {
          return <span>{messageTypes[message.messageType]}</span>;
        },
        accessor: 'messageType',
      },
      {
        header: 'Destination',
        accessor: 'destination',
      },
      {
        accessor: 'actions',
        cellComponent: (message: RecordingMessage) => {
          const isFirst = message.index === 1;
          const isLast = message.index === getSize();
          return (
            <div className="flex-table-actions text-center">
              <BzmIcon
                onClick={() => {
                  if (isFirst) {
                    return;
                  }
                  props.moveMessage(message, Move.start);
                }}
                variant={'icon-bzm-move-up'}
                className={clsx(isFirst ? 'text-muted' : 'hand-cursor', 'mr-3')}
                title={'Move message to beginning.'}
              />

              <BzmIcon
                onClick={() => {
                  if (isLast) {
                    return;
                  }
                  props.moveMessage(message, Move.end);
                }}
                variant={'icon-bzm-move-down'}
                className={clsx(isLast ? 'text-muted' : 'hand-cursor')}
                title={'Move message to end.'}
              />
            </div>
          );
        },
        isSortable: false,
        header: 'Actions',
        width: 100,
      },
    ];

    return colsDefinition;
  };

  const getExpandComponent = (message: RecordingMessage) => (
    <RecordingMessageSimpleView recordingMessage={getRecordingMessageWithFormat(message)} />
  );
  return (
    <DraggableTable
      cols={getTableColumns()}
      data={props.messages}
      onSelectionChange={props.onSelectionChange}
      onDragFinished={props.onDragFinished}
      isLoading={props.isLoading}
      expandableComponent={getExpandComponent}
      showSelectAll={false}
      selectedItems={props.selectedItems}
      sortBy={{ sortKey: 'index', readonly: true, direction: 'asc' }}
    />
  );
};

export default DraggableMessagesIndexTable;
